import * as React from 'react';
import { Link } from 'react-router-dom';
import 'bootstrap/dist/css/bootstrap.min.css';
import * as ReqType from '../../../types/ServerRequests';

interface Props {
    event: ReqType.Event;
}

interface State {
}

/**
 * Ce composant permet d'afficher une ligne de la liste event
 */
export class LigneEvent extends React.Component {
    state: State;
    props: Props;

    constructor(props: Props) {
        super(props);
    }

    render() {
        return (
            <tr key={this.props.event.id}>
                <td scope="row">{this.props.event.intitule}</td>
                <td scope="row">
                    {this.props.event.date_heure_debut.getHours() + 'h ' +
                     this.props.event.date_heure_debut.getMinutes() + 'mn ' }
                </td>
                <td scope="row">
                    {this.props.event.date_heure_fin.getHours() + 'h ' +
                    this.props.event.date_heure_fin.getMinutes() + 'mn ' }
                </td>
                <td scope="row">{this.props.event.description}</td>
                <td>
                    <Link to={'/schedule/' + this.props.event.id}>
                        <button className="btn btn-default">
                            <i className="fas fa-eye" />
                        </button>
                    </Link>
                </td>
            </tr>
        );
    }
}


// WEBPACK FOOTER //
// ./src/components/SchedulePage/internalComponents/LigneEvent.tsx